import styled from "styled-components";
export var ManageFavoriteAndFollowsContainer = styled.div.withConfig({
  displayName: "styles__ManageFavoriteAndFollowsContainer",
  componentId: "sc-1fzpsic-0"
})(["padding:0 16px;"]);